import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Breakpoint, ConditionalWrapper, Image as AndesImage, TextAlpha, Grid, } from '@yonderland/andes-react';
import { getPictureSrcset } from '../../util/ImageUtil';
const CAPTION_BG_COLOR = 'opacity-dark';
const toAndesPictureSourceSet = (srcset) => {
    if (!srcset) {
        return [];
    }
    return Object.entries(srcset).map(([width, source]) => ({
        source,
        descriptor: `(max-width: ${width}px)`,
    }));
};
const Image = ({ imagePath, alt = '', caption, captionPosition = 'below', lastModified, lazyLoad = false, link, target, renditions, hideOnMobile = false, analyticsId, }) => {
    const { imageCdnPrefix } = useAemConfig();
    const captionBellow = captionPosition === 'below';
    const boxProps = captionBellow
        ? { paddingBlock: '2' }
        : { backgroundColor: CAPTION_BG_COLOR, padding: '2' };
    const textProps = {
        as: 'span',
        variant: 'bodyXS',
        color: captionBellow ? 'subtle' : 'on-media',
        children: caption,
    };
    const sourceSet = toAndesPictureSourceSet(getPictureSrcset({ imagePath, renditions, lastModified }, imageCdnPrefix));
    const imageContainer = (_jsxs(Grid, { fullHeight: true, gap: 0, columns: captionBellow ? undefined : 'stack', children: [_jsx(Grid.Cell, { overflow: "hidden", children: _jsx(AndesImage, Object.assign({ source: imagePath, alt: alt, lazyLoad: lazyLoad, hasHover: !!link, asCover: true, fullHeight: true }, (sourceSet.length > 0 && { sourceSet, asPicture: true }))) }), caption && (_jsx(Grid.Cell, Object.assign({ justify: "start", align: "end" }, boxProps, { children: _jsx(TextAlpha, Object.assign({}, textProps)) })))] }));
    const container = link ? (_jsx("a", { href: link, target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, children: imageContainer })) : (imageContainer);
    return (_jsx(ConditionalWrapper, { condition: hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsx(ConditionalWrapper, { condition: !!analyticsId, wrapper: children => _jsx("div", { "data-analytics-bannerid": analyticsId, children: children }), children: container }) }));
};
export default Image;
